<template>
    <div ref="rootElem">
        <slot></slot>
    </div>
</template>

<script>
import {ref, onMounted, getCurrentInstance} from "vue";
import {
    transitionClassesOpen,
    transitionClassesClose,
    isTouchDevice,
    breakpointState
} from "@/utils";

export default {
    name: "main-navigation",
    setup(props, { emit }) {
        const rootElem = ref();
        const flyOutTimer = {};
        const flyOutNavigation = ref();
        const lastElementClick = ref(null);
        const { root } = getCurrentInstance();

        const initMobileNavigation = (mainMenu) => {
            for (let item of mainMenu) {
                let link = item.querySelector("a");
                if (link) {
                    link.addEventListener("click", e => {
                        root.setupState.toggleMobileNav(false);
                    });
                }

                let subNav = item.querySelectorAll("ul");
                if (
                    subNav[0] !== undefined &&
                    subNav[0].children !== undefined &&
                    subNav[0].children.length > 0
                ) {
                    let isActive = false;
                    let toggleNav = document.createElement("button");
                    toggleNav.classList.add(
                        "btn",
                        "material-symbols-outlined",
                        "mdc-button__icon-single"
                    );
                    toggleNav.innerText = "expand_more";
                    toggleNav.onclick = (e) => {
                        e.stopPropagation();
                        isActive = !isActive;
                        toggleNav.innerText = isActive
                            ? "expand_less"
                            : "expand_more";
                        if (isActive) {
                            transitionClassesOpen({
                                el: item,
                                dropDown: subNav[0],
                            });
                        } else {
                            transitionClassesClose({
                                el: item,
                                dropDown: subNav[0],
                            });
                        }
                    };
                    item.appendChild(toggleNav);

                    initMobileNavigation(subNav[0].children);
                }
            }
        };

        window.addEventListener("click", () => {
            lastElementClick.value = null;
        })

        const initNavigationLayer = (mainMenu) => {
            flyOutNavigation.value = document.querySelector('#flyOutNavigation');
            for (let item of mainMenu) {
                let subNav = item.querySelector("ul");
                if (
                    subNav !== null &&
                    subNav.children !== undefined &&
                    subNav.children.length > 0
                ) {
                    let flyOutWrapper = document.createElement("div");
                    flyOutWrapper.classList.add("page-header__flyout--wrapper");
                    flyOutWrapper.dataset.trigger = item.id;

                    let flyOut = document.createElement("div");
                    flyOut.classList.add("page-header__flyout--inner");

                    let elementWrapper = document.createElement("div");
                    elementWrapper.classList.add("element");

                    let copy = subNav.cloneNode(true);
                    let count = copy.childNodes.length;
                    let chunkSize = Math.ceil(count / 3);
                    const chunks = [];

                    for (let i = 0; i < copy.children.length; i += chunkSize) {
                        let myArray = Array.from(copy.children);
                        const chunk = myArray.slice(i, i + chunkSize);
                        chunks.push(chunk);
                    }

                    for (let i = 0; i < chunks.length; i++) {
                        let subList = document.createElement("ul");
                        for (let x = 0; x < chunks[i].length; x++) {
                            subList.appendChild(chunks[i][x]);
                        }
                        elementWrapper.appendChild(subList);
                    }

                    flyOut.appendChild(elementWrapper);
                    flyOutWrapper.appendChild(flyOut);
                    flyOutNavigation.value.appendChild(flyOutWrapper);

                    item.addEventListener("mouseenter", () => {
                        clearTimeout(flyOutTimer[item.id]);
                        flyOutTimer[item.id] = setTimeout(() => {
                            openLayer(item);
                        }, 400);
                    });

                    item.addEventListener("mouseleave", () => {
                        clearTimeout(flyOutTimer[item.id]);
                        closeLayer(item);
                    });

                    item.addEventListener("click", (e) => {
                        if (
                            isTouchDevice() &&
                            breakpointState.value.down.indexOf("tablet_portrait") !== -1 &&
                            lastElementClick.value != item
                        ){
                            e.preventDefault();
                            e.stopPropagation();
                            lastElementClick.value = item;
                        }
                    });

                    flyOutWrapper.addEventListener("mouseenter", () => {
                        clearTimeout(
                            flyOutTimer[flyOutWrapper.dataset.trigger]
                        );
                    });

                    flyOutWrapper.addEventListener("mouseleave", () => {
                        closeLayer(item);
                    });
                }
            }
        };

        const openLayer = (item) => {
            if (item.id !== undefined) {
                rootElem.value.querySelector("#" + item.id).classList.add("hover");
                const flyOut = flyOutNavigation.value.querySelector(
                    '[data-trigger="' + item.id + '"]'
                );
                flyOut.classList.add("opened");
                setTimeout(() => {
                    transitionClassesOpen({
                        el: flyOutNavigation.value,
                        dropDown: flyOutNavigation.value,
                        height: flyOut.offsetHeight
                    })
                },2)

            }
        };

        const closeLayer = (item) => {
            if (item.id !== undefined) {
                const flyOut = flyOutNavigation.value.querySelector(
                    '[data-trigger="' + item.id + '"]'
                );
                let h = flyOut.offsetHeight;
                const cL = flyOut.classList;
                if (cL.contains("open") || cL.contains("opened")) {
                    flyOutTimer[item.id] = setTimeout(() => {
                        rootElem.value.querySelector("#" + item.id).classList.remove("hover");
                        flyOut.classList.remove("opened");

                        //setTimeout(() => {
                            transitionClassesClose({
                                el: flyOutNavigation.value,
                                dropDown: flyOutNavigation.value,
                                height: h
                            })
                        //},10)

                    }, 400);
                }
            }
        };

        onMounted(() => {
            let menus = rootElem.value.querySelectorAll(".main-menu");
            menus.forEach(menu => {
                initNavigationLayer(menu.children);
                initMobileNavigation(menu.children);
            })
        });

        return {
            rootElem
        };
    },
};
</script>

<style lang="scss">

</style>
